import { gql } from '@apollo/client';

export const CANCEL_PURCHASE = gql`
  mutation CANCEL_PURCHASE($registrationId: String) {
    cancelPurchase(registrationId: $registrationId)
  }
`;
